import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchCartItems = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/ma-cart-list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 204) {
      return [];
    }
    return response.data.cart_items;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const deleteCartItem = async (token, id) => {
  try {
    const response = await axios.delete(
      `${API_URL}/ma-delete-cart-item/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      return response.data.message;
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};

export const updateCart = async (token, data) => {
  try {
    const response = await axios.put(`${API_URL}/ma-update-cart`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      return response.data.message;
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
